export default __webpack_public_path__ + "img/banner-1.8da980414a7cfbe529586c337644ae88.jpg";